import React from 'react';
import Head from 'next/head';
import useRouter from '@/Framework/hooks/useNextRouter';
import ReadyToStart from '@/dataroom/ui/components/Landing/researchRoom/components/ReadyToStart';
import Intro from './Intro';
import Faq from '@/Framework/UI/Pages/Landing/Sections/Faq';
import PricingTable from './PricingTable';
import { faqCollection } from '../../components/Faq/faqCollection';

const Pricing = () => {
  const { asPath } = useRouter();
  const activePanel = asPath.split('#')[1];

  return (
    <>
      <Head>
        <title>Pricing | Research Room</title>
        <meta
          name="description"
          content="Simple, transparent pricing backed by a 20% savings guarantee."
        />
      </Head>
      <Intro />
      <PricingTable />
      <Faq activePanel={ activePanel } collection={ faqCollection } />
      <ReadyToStart />
    </>
  );
};

export default Pricing;
